var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full dark:bg-slate-800"},[_c('iframe',{staticClass:"w-full h-full",attrs:{"src":"http://localhost:3001"}})])
}]

export { render, staticRenderFns }